import React from "react";
import escapeRegExp from "lodash/escapeRegExp";
import styles from "./highlighted.module.scss";

export const Highlighted: React.FC<{
  text: string;
  highlight: string;
  className?: string;
  testid?: string;
  tuvisId?: Record<string, string>;
}> = ({ text = "", highlight = "", className, testid, tuvisId }) => {
  if (!highlight.trim()) {
    return (
      <div className={className} data-testid={testid} {...(tuvisId ? tuvisId : {})}>
        {text}
      </div>
    );
  }
  const regex = new RegExp(`(${escapeRegExp(highlight)})`, `gi`);
  const parts = text.split(regex);
  return (
    <div className={className} data-testid={testid} {...(tuvisId ? tuvisId : {})}>
      {parts
        .filter((part) => part)
        .map((part, i) =>
          regex.test(part) ? (
            <span className={styles.highlightText} key={i}>
              {part}
            </span>
          ) : (
            <span key={i}>{part}</span>
          )
        )}
    </div>
  );
};
